import { render, staticRenderFns } from "./options-setting.vue?vue&type=template&id=7bd4d6bc&"
import script from "./options-setting.vue?vue&type=script&lang=js&"
export * from "./options-setting.vue?vue&type=script&lang=js&"
import style0 from "./options-setting.vue?vue&type=style&index=0&id=7bd4d6bc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports